import { withAuthenticationRequired } from '@auth0/auth0-react';
import { css } from '@emotion/react';
import { Outlet } from '@remix-run/react';
import { Hidden } from '@spark-web/hidden';
import { Stack } from '@spark-web/stack';
import { useTheme } from '@spark-web/theme';

import { DatadogRum } from '~/components/datadog-rum';
import Navbar from '~/components/navbar';
import { useAuth } from '~/hooks/useAuth';

import { Header } from '../../components/header';
import { useLaunchDarkly } from '../../hooks/useLaunchDarkly';

function AppLayout() {
  const { user } = useAuth();
  const theme = useTheme();
  useLaunchDarkly(user);

  return (
    <>
      <DatadogRum />

      {user && <Header user={user} />}

      <Stack as="main" css={css({ paddingTop: user ? '90px' : undefined, height: '100vh' })}>
        <Hidden below="desktop">
          <Navbar styles={{ width: 200 }} />
        </Hidden>
        <Stack
          height="full"
          css={css({
            [`@media (min-width: ${theme.breakpoint.desktop}px)`]: {
              marginLeft: 200,
            },
          })}
        >
          <Stack
            height="full"
            css={css({
              paddingRight: theme.spacing.large,
              paddingLeft: theme.spacing.large,
              [`@media (min-width: ${theme.breakpoint.desktop}px)`]: {
                paddingRight: theme.spacing.xlarge,
                paddingLeft: theme.spacing.xlarge,
              },
            })}
          >
            <Outlet />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}

export default withAuthenticationRequired(AppLayout);
